<template>
  <div class="product">
    <banner :img="productBanner" title="产品介紹" />
    <div class="product-content">
      <div class="lacking-wrap">
      <div class="lacking">
        <div class="yuying">
          <h3 class="title">渔鹰</h3>
          <p style="font-size:18px">渔场预报服务平台<br>一站式海洋卫星服务</p>
        </div>
        
        <div class="lacking-bottom">
          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/渔场预报.png" alt />
              <span>渔场预报</span>
            </div>
            <p>渔场位置，鱼群种类，质量渔获量，效益分析；</p>
          </div>

          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/海洋牧场.png" alt />
              <span>海洋牧场</span>
            </div>
            <p>对鱼虾贝藻等海洋资源进行有目的和有计划的海上放养；</p>
          </div>

          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/航运管理.png" alt />
              <span>航运管理</span>
            </div>
            <p>航线优化，风险预警，遇险船只和人员定位，最佳救援路线；</p>
          </div>

          <div class="lacking-bottom-item">
            <div class="lacking-bottom-item-img">
              <img src="../assets/img/海洋灾害.png" alt />
              <span>海洋灾害</span>
            </div>
            <p>台风、风暴潮、灾难性海难等海洋灾难检测预警，评估应急方案；</p>
          </div>
        </div>
      </div>
      <!-- 平台目标 -->
      <div class="target">
        <!-- <h3 class="title">渔鹰</h3> -->
        <p class="sub">“渔鹰-渔场预报服务平台（简称“渔鹰”，英文名“Fishawk”）”
          系利用卫星、飞机和水下机器人对海洋环境实施空天海立体协同监测，借助人工智能、大数据、
          云计算等技术为渔业领域用户提供“一站式”服务的专业渔业信息服务系统。产品主要用于分析渔情，
          帮助渔民高效寻找金枪鱼、
          马鲛、鱿鱼、沙丁鱼等渔场，以及监测预警海洋环境灾害，保证捕鱼作业安全，减少生命财产损失。</p>
        <!-- <div class="target-img">
          <img src="../assets/img/product_group_3_img.png" alt />
        </div> -->
      </div>
      </div>
      <div class="productWrap">
        <div>
          <p class="sub-title">产品web端</p>
          <img class="img1" src="../assets/img/product_web.png" alt="">
        </div>
        <hr>
        <div class="padding: 50px 0;">
          <p class="sub-title">产品移动端</p>
            <ul class="honor-show">
            <li v-for="(honor,index) in honorList" :key="index">
              <img
                v-lazy="honor.url"
                @click="dialogTableVisible = true ;dialogUrl = honor.url;dialogTitle= honor.title"
              />
            </li>

          </ul>
          <!-- <img class="img2" src="../assets/img/产品移动端界面.png" alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  data() {
    return {
      honorList: [
        {
          url: require("../assets/img/product_mobile1.jpg" ),
          title:'海洋底层鱼类渔场预测系统'
        },
        {
          url: require("../assets/img/product_mobile2.jpg" ),
          title:'海洋信息服务系统'
        }],
      loading: true,
      videoSrc: "http://www.shkjem.com/video/kj.mp4",
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "http://www.shkjem.com/video/kj.mp4" //url地址
          }
        ],
        //poster: "../assets/img/home_top.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true //全屏按钮
        }
      },
      productBanner:require("../assets/img/productBanner.jpg")
    };
  },
  components: {
    Banner
  },
  created() {
    // this.$http
    //   .get(
    //     "DataDictionary/GetDataDictionaryAll?key=%E4%BA%A7%E5%93%81%E8%A7%86%E9%A2%91%E9%93%BE%E6%8E%A5"
    //   )
    //   .then(response => {
    //     this.videoSrc = response.data[0].Content;
    //     window.console.log(this.videoSrc);
    //     this.loading = false;
    //   })
    //   .catch(function(error) {
    //     window.console.log(error);
    //   });
  }
};
</script>

<style lang="scss" scoped>
.product {
  width: 100%;
  height: 100%;
  // background-color: #14679f;
}

.product-content {
  width: 1240px;
  margin: 0 auto;
  background-color: #fff;
}

.p-video {
  width: 1000px;
  margin: 0 auto;
  padding: 60px 0;
}
        .honor-show {
          width: 1000px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          justify-content: center;

          li {
            list-style: none;
            width: 30%;
            margin: 0 20px;
            // border: 1px solid palegoldenrod;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
//传统管理模式不足
.lacking-wrap{
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    // background: url(../../img/product-group-intro-bg.png) no-repeat 50%;
    // background: url(../assets/img/product-group-intro-bg.png) no-repeat 50%;
    // opacity: .4;
}
.lacking {
  height: 360px;
  padding: 20px 0;
  //margin: 20px 0;
  .lacking-bottom {
    display: flex;
    justify-content: space-around;
    padding: 0 100px;

    .lacking-bottom-item {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      justify-content: center;

      .lacking-bottom-item-img {
        display: flex;
        align-items: center;
        span{
          font-size: 16px;
        }
      }
    }
    p {
      font-size: 16px;
      color: #909399;
      text-align: start;
      margin: 5px 0;
      min-height: 63px;
    }
  }
  .yuying{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 50px;
    line-height: 1.8;
    .title{
      margin-right: 30px;
      color: #4b8dbc;
    }
  }
}

//平台目标
.target {
  margin-top: 10px;
  &-img {
    margin-top: 50px;
    text-align: center;
  }
}
.sub{
  font-size: 20px;
  text-align: start;
  margin: 0 200px;
  text-indent: 40px;
  margin-bottom: 80px;
  line-height: 1.8;
}

//
.modular {
  margin-top: 50px;
  .modular-content {
    padding: 50px 50px;
    display: flex;
    justify-content: space-around;
  }
}
.modular-content-same {
  width: 182px;
  height: 405px;

  .same-item {
    height: 70px;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;

    .same-item-img {
      width: 70px;
      height: 70px;
      line-height: 100px;
      background: #1667a0;
      border-radius: 50%;
      text-align: center;
    }
    p {
      color: #1667a0;
      font-weight: 700;
      line-height: 70px;
    }
  }
}

.modular-content-center {
  width: 355px;
  height: 355px;
  img {
    width: 100%;
  }
}
//公共样式
.title,
.eTitle {
  font-size: 50px;
  font-weight: 400;
  color: #333;
  text-align: center;
}
.eTitle {
  font-size: 30px;
  padding: 10px 0;
}

.productWrap{
  overflow: hidden;
  margin-top: 50px;
  text-align: center;
  .sub-title{
    margin-bottom: 10px;
    font-size: 20px;
    color: #4b8dbc;
    font-weight: bold;
  }
  hr{
    margin: 20px 0;
  }
  .img1{
    width: 980px;
  }
  .img2{
    margin-bottom: 50px;
  }
}
</style>